import React from "react";
import FlexColumn from "../../core/FlexColumn";
import HomeworkListItem from "./HomeworkListItem";

function HomeworkList({ homeworks }) {
  return (
    <FlexColumn rowGap={8} role="list" width="100%" height="100%">
      {homeworks.map((homework) => (
        <HomeworkListItem homework={homework} key={homework.id} />
      ))}
    </FlexColumn>
  );
}

export default HomeworkList;
